import base from './secrets/development'

export type Secrets = {
  meetingHost: string
}

export default base
